const MINIMUM_SECONDS = 180

export const convertHoursToSeconds = (hours: number, applyMinimum: boolean = false): number => {
  if (typeof hours !== 'number' || isNaN(hours)) return applyMinimum ? MINIMUM_SECONDS : 0
  return applyMinimum ? Math.max(hours * 3600, MINIMUM_SECONDS) : hours * 3600
}
